import { TransactionsExchangeTypeBuy } from "@/components/Transactions/Exchange/TypeBuy"
import { TransactionsExchangeTypeSell } from "@/components/Transactions/Exchange/TypeSell"
import { useStoreClient } from "@usher/pe-client-front-end-lib"
import { TransactionsExchangeTypeIBAN } from "./TypeIBAN"

export const TransactionsExchange = () => {
  const { card_active, iban_active } = useStoreClient((state) => state.user)
  return (
    <>
      {card_active && <TransactionsExchangeTypeSell />}
      {iban_active && <TransactionsExchangeTypeIBAN />}
      <TransactionsExchangeTypeBuy />
    </>
  )
}
